import { QCONTINUITY_ENTITY } from 'app/shared/constant';
import { CommonSectionIds } from '../common.models';
import { INSTALLATION_TYPE, INSTALLATION_TYPE_ID } from 'app/shared/models/location-details';

export const RainSectionIds = {
    BasicInfo: CommonSectionIds.BasicInfo,
    DataDelivery: CommonSectionIds.DataDelivery,
    Advanced: CommonSectionIds.Advanced,
    DialogActions: CommonSectionIds.DialogActions,

    RainInfo: 'rain-info-section-id',
    RainSensor: 'rain-sensor-section-id',
    RainAlarm: 'rain-alarm-section-id',
};

export enum RainInfoFieldIds {
    Sensor = 'rain-alert-sensor',
    IntensityInterval = 'rain-alert-intensityinterval',
    StoreTemperature = 'rain-alert-storetemperature',
    StoreBattery = 'rain-alert-storebattery',
    LogIntensity = 'rain-alert-logintensity',
    LogUkIntensity = 'rain-alert-logukintensity',
}

export enum RainSensorFieldIds {
    RainPerTip = 'rain-alert-rainpertip',
    DataLogMode = 'rain-alert-datalogmode',
}

export enum RainAlarmFieldIds {
    AlarmEnable = 'rain-alert-alarmEnable',
    AlarmThreshold = 'rain-alert-alarmThreshold',
    AlarmReturnToNormal = 'rain-alert-alarmReturnToNormal',
}

export const RAIN_INSTALLATION_CONSTANT = {
    rain: {
        installationID: 0,
        installationType: 'RainGauge',
        shapeType: 'RainGauge',
        installationDesc1: 'Rain',
        installationDesc2: '',
        installationDesc3: '',
        installationDesc4: '',
        installationDesc5: '',
        lookupDesc: 'Nice',
        monitoringPoint: 1,
        wasCreatedFromImport: false,
    },
    installationtypeid: INSTALLATION_TYPE_ID[INSTALLATION_TYPE.RAIN],
    qFinalEntityID: QCONTINUITY_ENTITY,
};

export const RAIN_CONFIGURATION_CONSTANT = {
    ftpdeliveryfast: 0,
    ftpdeliverynormal: 0,
    ftpfolder: '',
    ftpformat: 'ADS',
    ftpmode: 'Active',
    ftppassword: '',
    ftpserver: '',
    ftpusername: '',
};
